import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import { Formik } from 'formik';
import * as yup from 'yup';
import moment from 'moment';
import { isArray } from 'lodash';
import { noteBoxTypes } from 'modules/enums/notebox-types';
import { onboardingFormData } from 'modules/form-data';

import Toast from 'modules/toast';

import apiFetch from 'modules/api-fetch';
import IMAGES from 'modules/assets/web';

import {
  isExistingOnboardingEntry,
  hasLegacyOnboardingData,
} from 'modules/functions/src/hasExistingOnboardingData';
import DisplayLegacyOnboardingEntry from 'modules/components/web/DisplayLegacyOnboardingEntry';

import OnboardingHeaderBg from './OnboardingHeader';
import OnboardingForm from './OnboardingForm';
import OnboardingFooter from './OnboardingFooter';

import CompletedQuestionnaireModal from './CompletedQuestionnaireModal';

class Onboarding extends React.Component {
  static propTypes = {
    myQuestionnaire: PropTypes.object.isRequired,
    myClient: PropTypes.object.isRequired,
    myTrainer: PropTypes.object.isRequired,
    toggleSidebar: PropTypes.func.isRequired,
    isHiddenSidebar: PropTypes.bool,
  };

  static defaultProps = {
    isHiddenSidebar: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      currentGroup: 1,
      visited: [true, false, false, false, false, false, false],
      isSubmitPossible: false,
      showOnboardingModal: false,
      isExistingEntry: null,
    };
    this.onboardingRef = React.createRef();
  }

  componentDidMount = () => {
    if (isExistingOnboardingEntry(this.props.myQuestionnaire)) {
      this.setState({
        visited: [true, true, true, true, true, true, true],
      });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.currentGroup !== this.state.currentGroup) {
      this.onboardingRef.current.scrollTop = 0;
    }
  };

  setInitialValues = () => {
    if (isExistingOnboardingEntry(this.props.myQuestionnaire)) {
      return JSON.parse(this.props.myQuestionnaire.data[0].questionnaire);
    }

    const initialValues = {
      heightFeet: '',
      heightInches: '',
      pronouns: '',
      daysWorkOut: '',
      daysCommitWorkout: '',
      daysBestWorkOuts: '',
      currentTrainingProgram: '',
      completingWorkOuts: '',
      availableWorkOuts: [],
      pastWorkOuts: '',
      nutritionalExperience: '',
      mostEatMeals: '',
      specificDietaryRestriction: '',
      biggestPastNutrition: '',
      cigarettesPerWeek: '',
      drinksPerWeek: '',
      yourHousehold: '',
      howMuchSupport: '',
      existingPractitionerSupport: '',
      currentStressLevel: [],
      bigProjectMostHelpful: '',
      whichDescribesYouBest: '',
      succeededInChangingHabit: '',
      additionalEquipment: '',
      desiredCoachNumber: '',
      phoneNumber: '',
      foundSuccess: '',
      nerdyHobbies: '',
      wantToKnowAboutCoach: '',
      hoursSleepNight: '',
      mailingAddress1: '',
      mailingAddress2: '',
      state: '',
      city: '',
      country: '',
      zip: '',
    };

    return initialValues;
  };

  setVisited = (stepNumber) => {
    const { visited } = this.state;

    visited[stepNumber] = true;
    this.setState({
      visited,
    });
  };

  setSubmitPossible = (formikProps) => {
    this.setState(
      {
        isSubmitPossible: true,
      },
      () => {
        this.submitForm(formikProps.values, formikProps);
      },
    );
  };

  calculateHeight = (values) => {
    // If feet and inches are set, full calculations
    // If either is null, just use that
    let retval = null;
    if (values.heightFeet && values.heightInches) {
      retval = values.heightFeet * 12 + values.heightInches;
    } else if (values.heightFeet) {
      retval = values.heightFeet * 12;
    }

    return retval;
  };

  emailMessages = () => {
    const message = `
    <p style="font-size: 18px; line-height: 24px">High five,  ${this.props.myClient.data[0].firstName}! You're the best! </p>
    <p style="font-size: 18px; line-height: 24px">Thanks for telling us a little more about yourself. We’ll use the info you provided along with the notes from your initial call to match you up with a Nerd Fitness Coach who has the strengths to help you succeed! Once you’re up on the waiting list, we’ll be in touch with more information about your Coach.</p>
    <p style="font-size: 18px; line-height: 24px">I also wanted to remind you that, as a benefit for joining the Nerd Fitness Coaching Family, you’ve also gained complimentary access to <a href="https://prime.nerdfitness.com/login/">Nerd Fitness Prime.</a></p>
    <p style="font-size: 18px; line-height: 24px">Nerd Fitness Prime is separate from Nerd Fitness Coaching, and includes self-paced programming that users can follow on their journeys to get healthy.</p>
    <p style="font-size: 18px; line-height: 24px">In Coaching, you’ll of course have a mentor to guide you through the process and build tasks collaboratively that fit your specific lifestyle and goals. </p>
    <p style="font-size: 18px; line-height: 24px">If you want to completely ignore NF Prime and wait to chat with your Coach, that’s totally fine. You can stop reading this email right now, do 5 push ups, and keep an eye on your email inbox for our recommended Coach pairing.</p>
    <p style="font-size: 18px; line-height: 24px">However, if you’d like to start exploring some of that self-paced content for ideas or strategies, you can utilize <a href="https://prime.nerdfitness.com/login/">Nerd Fitness Prime</a> at any time using the same login info you just created. If anything looks appealing, be sure to mention it to your Coach so you two can talk through the best ways to incorporate it into your plan. You will maintain complimentary access for as long as you’re a member of NF Coaching.</p>
    <p style="font-size: 18px; line-height: 24px">We’ll be in touch soon, but if you have any questions don’t hesitate to touch base by replying to this email!</p>
    <p style="font-size: 18px; line-height: 24px">For the Rebellion!</p>
    <p style="font-size: 18px; line-height: 24px">    -Team Nerd Fitness</p>`;

    /* 
    <p style="font-size: 20px; line-height: 24px">So does this waiting period give you permission to just sit around and wait for your name to be called? Heck no! To get a jump start on your training, we'd like to invite you to join our Nerd Fitness Academy and begin reading through the Mindset and Nutrition modules; your Coach will embrace many of these philosophies in your programming! Already a member? Awesome! Give those sections a skim as a refresher.
    </p>
    <p style="font-size: 20px; line-height: 24px">Click below to set up your complimentary account. Choose the gender you identify with most.
    </p>
    <p style="font-size: 20px; line-height: 24px">
    <table border="0" cellspacing="0" cellpadding="0" style="margin-bottom: 25px; margin-right: auto; margin-left: auto;">
    <tr>
    <td bgcolor="#C73737" style="padding: 12px 18px 12px 18px; border-radius:3px; " align="center"><a href="https://www.nerdfitness.com/signup/884560?discount_field=yes&coupon_code=comped-academy-for-waiting-list" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; color: #ffffff; text-decoration: none; display: inline-block;">Join the Nerd Fitness Men's Academy</a></td></tr></table>
    </p><p><table border="0" cellspacing="0" cellpadding="0" style="margin-right: auto; margin-left: auto;">
    <tr><td bgcolor="#C73737" style="padding: 12px 18px 12px 18px; border-radius:3px; margin-right: auto; margin-left: auto;" align="center"><a href="https://www.nerdfitness.com/signup/884617?discount_field=yes&coupon_code=comped-academy-for-waiting-list" target="_blank" style="font-size: 16px; font-family: Helvetica, Arial, sans-serif; font-weight: normal; color: #ffffff; text-decoration: none; display: inline-block;">Join the Nerd Fitness Women's Academy</a></td></tr></table>
    </p>
    <p style="font-size: 20px; line-height: 24px">While you wait to hear from us, take 10 minutes of self-reflection and consider this bonus: <span class="font-italic">when the going gets tough (or stressful or busy) and prioritizing yourself is the LAST thing on your mind, how can your Coach best serve you?</span>
    </p>
    */

    this.sendEmail('You did it!', message, this.props.myClient.data[0].email);

    const messageRecipient =
      this.props.myTrainer.data.length > 0 &&
      this.props.myTrainer.data &&
      this.props.myTrainer.data[0].email
        ? this.props.myTrainer.data[0].email
        : 'coaching@nerdfitness.com';

    const message2 = `<p style="font-size: 20px; line-height: 24px">${this.props.myClient.data[0].firstName} ${this.props.myClient.data[0].lastName} finished the onboarding questionnaire. Email: ${this.props.myClient.data[0].email}</p><p style="font-size: 20px; line-height: 24px">Hop to it!</p>`;

    this.sendEmail('Questionnaire done', message2, messageRecipient);
  };

  sendEmail = async (subject, body, destination) => {
    const config = {
      url: 'Client/SendEmail',
      method: 'POST',
      body: {
        body,
        subject,
        email: destination,
      },
    };
    try {
      // console.devLog.info('Sending ze email', config);
      await apiFetch(config);
    } catch (e) {
      console.log('Config??', config);
      console.error('Error sending the email:', e);
    }
  };

  submitForm = async (values, formikProps) => {
    const { isSubmitPossible, currentGroup } = this.state;
    const { forceUpdate } = queryString.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    });
    const hasPreviouslySubmitted = isExistingOnboardingEntry(
      this.props.myQuestionnaire,
    );

    // const clientHasLegacyOnboardingData = hasLegacyOnboardingData(
    //   this.props.myQuestionnaire,
    // );
    if (isSubmitPossible && currentGroup === 7) {
      const url =
        isExistingOnboardingEntry(this.props.myQuestionnaire) ||
        this.state.isExistingEntry
          ? 'Client/UpdateQuestionnaire'
          : 'Client/CreateQuestionnaire';

      const body = { ...this.props.myQuestionnaire.data[0] };
      body.questionnaire = JSON.stringify(values);

      const config = {
        url,
        method: 'POST',
        body,
      };

      // TODO - if we just created it and the user might change anything then hit update, we need to handle that.
      // Probably just navigate them away from this page to get around that problem.
      try {
        await apiFetch(config);
        // Send the values to the update funciton so it can combine existing data and new information into the client model

        if (!forceUpdate) {
          // Email coaching that this client has completed onboarding
          // also sends a success message to the client
          this.emailMessages();
        }

        this.updateClientInfo(values);
        this.updateClientBoxes(values);
        Toast.success('Submitted!');
        // Submit their onboarding survey to an endpoint to update their profile
        // Redirect the user to chat
        // this.props.onUpdated();
        // throw up a modal that tells the user they're all done and redirects them on close on matter what
        this.setState({
          showOnboardingModal: true,
          isExistingEntry: true,
        });
        if (hasPreviouslySubmitted) {
          formikProps.setSubmitting(false);
        }
      } catch (err) {
        Toast.error(`Error submitting message: ${err}`);
      }
      // Don't uncomment this until the above comment is addressed, otherwise uses could hit the create endpoint more than once
      // formikProps.setSubmitting(false);
    } else formikProps.setSubmitting(false);
  };

  updateClientInfo = async (values) => {
    // console.devLog.info('Update client info body??');
    const clientInfo = {
      ...this.props.myClient.data[0],
      ...values,
      height: this.calculateHeight(values),
      questionnaireVersion: onboardingFormData.version,
      utcOffset: moment().utcOffset(),
    };

    const config = {
      url: 'Client/UpdateClient',
      method: 'POST',
      body: clientInfo,
    };

    // console.devLog.info('Config:', config);
    try {
      await apiFetch(config);
    } catch (err) {
      Toast.error(`Error submitting message: ${err}`);
    }
  };

  updateClientBoxes = async (values) => {
    // Map existing onboarding field to notebox types
    const fieldBoxMap = {
      nerdyHobbies: 'rapportNotes',
      injuries: 'currentInjuries',
      daysWorkOut: 'workoutHabits',
      daysCommitWorkout: 'workoutHabits',
      daysBestWorkOuts: 'workoutHabits',
      currentTrainingProgram: 'workoutHabits',
      availableWorkOuts: 'equipment',
      additionalEquipment: 'equipment',
      pastWorkOuts: 'struggles',
      nutritionalExperience: 'nutritionHabits',
      comfortableInTheKitchen: 'nutritionHabits',
      mostEatMeals: 'nutritionHabits',
      specificDietaryRestriction: 'healthNotes',
      biggestPastNutrition: 'struggle',
      cigarettesPerWeek: 'lifestyleHabits',
      drinksPerWeek: 'lifestyleHabits',
      hoursSleepNight: 'lifestyleHabits',
      yourHousehold: 'lifestyleHabits',
      howMuchSupport: 'lifestyleHabits',
      existingPractitionerSupport: 'lifestyleHabits',
      desiredCoachNumber: 'rapportNotes',
      foundSuccess: 'nutritionHabits',
      wantToKnowAboutCoach: 'rapportNotes',

      // New
      focusesPassions: 'rapportNotes',
      importantPeoplePets: 'rapportNotes',
      interestingFact: 'rapportNotes',
      characterLike: 'rapportNotes',
      attractedNFCoaching: 'rapportNotes',
      nervousAboutJourney: 'rapportNotes',
      coachExpectations: 'rapportNotes',
      coachAccountability: 'retentionNotes',
      obstacles: 'struggles',
      coachSupportTough: 'rapportNotes',
      startingCoupleWeeksComingUp: 'struggles',
      adjustmentConfidence: 'struggles',
      fitnessExperience: 'workoutHabits',
      fitnessSuccessFirstMonth: 'goals',
      extraEquipmentLearnOrDislike: 'equipment',
      exerciseActivitiesRegular: 'workoutHabits',
      concerns: 'healthNotes',
      scaleChangeFitnessHabits: 'workoutHabits',
      workoutLocation: 'workoutHabits',
      averageDayEating: 'nutritionHabits',
      nutritionSuccessFirstMonth: 'goals',
      nutritionFutureGoals: 'goals',
      nutritionChanges: 'nutritionHabits',
      scaleEnjoyCooking: 'nutritionHabits',
      preparesMeals: 'nutritionHabits',
      eatingStress: 'nutritionHabits',
      unhealthyFoodRelationships: 'nutritionHabits',
      troubleAvoidingFoods: 'nutritionHabits',
      foodEatMoreDislike: 'nutritionHabits',
      scaleReadyNutritionHabits: 'nutritionHabits',
      lifestyleMindsetHabits: 'lifestyleHabits',
      scaleSleepQuality: 'lifestyleHabits',
      travel: 'lifestyleHabits',
      stressCatalyst: 'lifeStyleHabits',
      averageWeekendTime: 'lifestyleHabits',
      scaleMindsetChanges: 'lifestyleHabits',
      prioritiesFirst: 'quickSummary',
      prioritiesSecond: 'quickSummary',
      bigProjectMostHelpful: 'retentionNotes',
      whichDescribesYouBest: 'retentionNotes',
      succeededInChangingHabit: 'retentionNotes',
    };

    const valuesWithMappedKeys = {};

    // Take each of the values. If it matches a key in the fieldBoxMap then replace the value's key with the notebox key.
    // Then do an API call for each one that needs it to create an entry
    Object.entries(values).forEach((entry) => {
      // transform the keys
      // console.devLog.info('Entry...', entry);
      let key = entry[0];
      const originalKey = entry[0];
      if (key in fieldBoxMap) {
        // console.devLog.info('Key is found in fieldBoxMap:', entry[0]);
        // console.devLog.info('New key:', fieldBoxMap[entry[0]]);
        // eslint-disable-next-line prefer-destructuring
        valuesWithMappedKeys[fieldBoxMap[entry[0]]] = entry[1];
        // Replace the existing key for the object with our correct one for the notebox types
        key = fieldBoxMap[entry[0]];
      }

      if (entry[1] === '' || entry[1].length <= 0 || !(key in noteBoxTypes)) {
        // Do nothing
      } else {
        // Create a notebox entry for this response, lets gooooo
        let value = entry[1];
        if (isArray(entry[1])) {
          value = entry[1].join();
        }
        value = `${originalKey} : ${value}`;
        const body = {
          clientId: this.props.myClient.data[0].id,
          section: noteBoxTypes[key],
          notes: value,
        };

        const config = {
          url: 'Client/CreateTrainerNotes',
          method: 'POST',
          body,
        };

        try {
          apiFetch(config);
        } catch (e) {
          console.devLog.info('Error saving notebox entry:', e);
        }
      }

      //
    });
  };

  validationSchema = () => {
    const { currentGroup } = this.state;

    switch (currentGroup) {
      case 1:
        return yup.object().shape({
          pronouns: yup.string().required('Required question'),
          nickname: yup.string().required('Required question'),
          birthday: yup.object().momentDate().required('Required question'),
          heightFeet: yup.number(),
          mailingAddress1: yup.string().required('Required question'),
          city: yup.string().required('Required question'),
          zip: yup.string().required('Required question'),
          heightInches: yup.number(),
          phoneNumber: yup
            .string()
            .phone()
            .required(
              'Must be a valid phone number. Please include country code for non-US numbers',
            ),
          unitPreferences: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          // .phone('Must be a valid phone number with country code'),
        });
      case 2:
        return yup.object().shape({
          focusesPassions: yup.string().required('Required question'),
          importantPeoplePets: yup.string().required('Required question'),
          nerdyHobbies: yup.string(),
        });
      case 3:
        return yup.object().shape({
          attractedNFCoaching: yup.string().required('Required question'),
          nervousAboutJourney: yup.string().required('Required question'),
          excitedAbout: yup.string().required('Required question'),
          retentionNotes: yup.string().required('Required question'),
          desiredCoachNumber: yup.string().required('Required question'),
          whichDescribesYouBest: yup.string(),
          bigProjectMostHelpful: yup.string(),
          succeededInChangingHabit: yup.string(),
          coachExpectations: yup.string().required('Required question'),
          // coachAccountability: yup.string().required('Required question'),
          obstacles: yup.string().required('Required question'),
          coachSupportTough: yup.string().required('Required question'),
          startingCoupleWeeksComingUp: yup
            .string()
            .required('Required question'),
        });
      // FITNESS
      case 4:
        return yup.object().shape({
          fitnessExperience: yup.string().required('Required question'),
          pastWorkOuts: yup.string().required('Required question'),
          fitnessSuccessFirstMonth: yup.string().required('Required question'),
          goals: yup.string().required('Required question'),
          timePerWorkout: yup.string().required('Required question'),
          workoutLocation: yup.string().required('Required question'),
          additionalEquipment: yup.string().required('Required question'),
          extraEquipmentLearnOrDislike: yup
            .string()
            .required('Required question'),
          exerciseActivitiesRegular: yup.string().required('Required question'),
          injuries: yup.string().required('Required question'),
          scaleChangeFitnessHabits: yup.string().required('Required question'),
          daysWorkOut: yup.mixed().nullable(true).required('Required question'),
          daysCommitWorkout: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          daysBestWorkOuts: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
        });
      // Nutrition
      case 5:
        return yup.object().shape({
          // nutritionalExperience: yup.string().required('Required question'),
          comfortableInTheKitchen: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          biggestPastNutrition: yup.string().required('Required question'),
          foundSuccess: yup.string().required('Required question'),
          averageDayEating: yup.string().required('Required question'),
          nutritionSuccessFirstMonth: yup
            .string()
            .required('Required question'),
          nutritionFutureGoals: yup.string().required('Required question'),
          nutritionChanges: yup.string().required('Required question'),
          scaleEnjoyCooking: yup.string().required('Required question'),
          preparesMeals: yup.string().required('Required question'),
          specificDietaryRestriction: yup
            .string()
            .required('Required question'),
          scaleReadyNutritionHabits: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
        });
      // Lifestyle-mindset
      case 6:
        return yup.object().shape({
          cigarettesPerWeek: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          drinksPerWeek: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          hoursSleepNight: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          scaleSleepQuality: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          currentStressLevel: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          scaleMindsetChanges: yup
            .mixed()
            .nullable(true)
            .required('Required question'),
          yourHousehold: yup.string().required('Required question'),
          howMuchSupport: yup.string().required('Required question'),
          existingPractitionerSupport: yup
            .string()
            .required('Required question'),
          lifestyleMindsetHabits: yup.string().required('Required question'),
          travel: yup.string().required('Required question'),
          stressCatalyst: yup.string().required('Required question'),
          averageWeekdayTime: yup.string().required('Required question'),
          averageWeekendTime: yup.string().required('Required question'),
        });
      case 7:
        return yup.object().shape({});
      default:
        return null;
    }
  };

  stepMoveForward = () => {
    const { visited, currentGroup } = this.state;
    // console.devLog.info('Step move forward formik', formikProps);
    // formikProps.validateForm();
    visited[currentGroup] = true;
    this.setState({
      currentGroup: currentGroup + 1,
      visited,
    });
  };

  navigateToStep = (stepNumber) => {
    const { visited } = this.state;
    console.devLog.info('Navigate to step..', stepNumber);
    if (visited[stepNumber - 1]) {
      this.setState({ currentGroup: stepNumber });
    }
  };

  isCompletedStep = (stepNumber) => {
    const { currentGroup } = this.state;

    const result = currentGroup >= stepNumber ? ' bg-primary' : '';
    return result;
  };

  render() {
    const { groups } = onboardingFormData;
    const { toggleSidebar, isHiddenSidebar } = this.props;
    const { currentGroup } = this.state;

    console.devLog.info('Current group?', currentGroup);
    // console.devLog.info('Onboarding all props:', this.props);
    const clientHasLegacyOnboardingData = hasLegacyOnboardingData(
      this.props.myQuestionnaire,
    );
    const isExistingOnboardingEntryBool = isExistingOnboardingEntry(
      this.props.myQuestionnaire,
    );
    // console.devLog.info('Is existing??', isExistingOnboardingEntryBool);
    return (
      <div
        ref={this.onboardingRef}
        className={`page onboarding flex-1 col-md-9 ml-auto p-0${
          isHiddenSidebar ? ' ' : ''
        }`}
      >
        <OnboardingHeaderBg currentGroup={currentGroup} groups={groups} />
        {this.state.showOnboardingModal && (
          <CompletedQuestionnaireModal
            // handleHideModal={this.hideOnboardingModal}
            myClient={this.props.myClient}
          />
        )}
        <div className="page--content round-image-space-include">
          <img
            alt="page-background"
            className="page-background-image"
            src={IMAGES.DOTTED_BACKGROUND}
          />
          {clientHasLegacyOnboardingData && currentGroup === 1 && (
            <div className="col-md-12">
              <DisplayLegacyOnboardingEntry
                legacyQuestionnaire={
                  this.props.myQuestionnaire.data[0].legacyQuestionnaire
                }
              />
            </div>
          )}
          <Formik
            initialValues={this.setInitialValues()}
            validationSchema={this.validationSchema}
            onSubmit={this.submitForm}
            render={(formikProps) => {
              // console.log('FP?', formikProps);
              return (
                <OnboardingForm
                  groups={groups}
                  formikProps={formikProps}
                  currentGroup={currentGroup}
                  onNextHandler={this.stepMoveForward}
                  setSubmitPossible={this.setSubmitPossible}
                  isExistingEntry={isExistingOnboardingEntryBool}
                  isInitialValid={isExistingOnboardingEntryBool}
                  myTrainer={this.props.myTrainer}
                />
              );
            }}
          />
        </div>
        <OnboardingFooter
          isHiddenSidebar={isHiddenSidebar}
          toggleSidebar={toggleSidebar}
          navigateToStep={this.navigateToStep}
          isCompletedStep={this.isCompletedStep}
        />
      </div>
    );
  }
}

export default withRouter(Onboarding);
